import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import styles from './ImpersonationBar.module.css';

const mapStateToProps = (state: RootState) => ({
    ...state.siteContext,
    showImpersonationBar: state.siteContext.impersonating
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

function ImpersonationBar({
    showImpersonationBar,
    impersonatingStateKey,
    errorCode,
    errorDetail
}: PropsFromRedux) {
    function renderErrors() {
        if (errorCode) {
            return (
                <div>
                    <small>
                        <strong>{errorCode}</strong> {errorDetail}
                    </small>
                </div>
            );
        }
    }

    if (errorCode || showImpersonationBar) {
        return (
            <div
                className={styles.ImpersonationBar}
                data-testid="impersonationBar"
            >
                Impersonating state key:{' '}
                <strong>{impersonatingStateKey}</strong>
                {renderErrors()}
            </div>
        );
    }

    return null;
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ImpersonationBar);
